import { apiSlice } from '../../app/api/apiSlice'
import { urlConfig } from '../../config'

const emailSlice = apiSlice.injectEndpoints({
  endpoints: build => ({
    sendVerificationEmail: build.mutation({
      query: body => ({
        url: `${urlConfig.authBaseUrl}/auth/users/resend-email`,
        method: 'POST',
        body,
      }),
    }),

    verifyEmail: build.mutation({
      query: body => ({
        url: `${urlConfig.authBaseUrl}/auth/users/verify`,
        method: 'POST',
        body,
      }),
    }),
  }),
})

export const { useSendVerificationEmailMutation, useVerifyEmailMutation } =
  emailSlice
